import { PreviewStatus } from '../../../../../core/records/entities/metadata/metadata.entity';
import { Cell, CellType } from '../_base/table-cell.entity';

export interface ThumbailCellInterface {
    imgSrc?: string;
    imgAlt?: string;
    detailUrl?: string;
    previewStatus?: PreviewStatus;
}

export class ThumbnailCell extends Cell implements ThumbailCellInterface {
    public imgSrc?: string;
    public imgAlt?: string;
    public detailUrl?: string;
    public previewStatus?: PreviewStatus = PreviewStatus.Ready;

    constructor({ imgSrc, imgAlt, detailUrl, previewStatus }: ThumbailCellInterface) {
        super(CellType.MEDIA);
        this.imgSrc = imgSrc;
        this.imgAlt = imgAlt;
        this.detailUrl = detailUrl;
        this.previewStatus = previewStatus;
    }
}
